import { Wrapper } from '@american-autonomy/ag-ui';

import useTranslation from 'pages/MaintenancePage/hooks/useTranslation';

import { TEST_ID } from './constants';
import type { FunctionComponent, LifecycleLabelMap, Props } from './types';

import styles from './styles.module.scss';

// Single caption line attributing the drone's manual lifecycle change,
// e.g. "Set to Claimed by Dana Whitfield · 7/3/2026".
const LifecycleLogLine: FunctionComponent<Props> = ({ className = '', log, testId = TEST_ID }) => {
    const t = useTranslation();
    const lifecycleLabels: LifecycleLabelMap = {
        claimed: t.STATUS_CLAIMED,
        disabled: t.STATUS_DISABLED,
        enabled: t.STATUS_ENABLED,
        released: t.STATUS_RELEASED
    };

    return (
        <Wrapper className={`${styles.lifecycleLogLine} ${className}`} testId={testId}>
            {t.LIFECYCLE_SET_BY({
                status: lifecycleLabels[log.status],
                when: new Date(log.at).toLocaleDateString(),
                who: log.by
            })}
        </Wrapper>
    );
};

export default LifecycleLogLine;
